import Swiper from "https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.mjs";

(() => {
  if (!customElements.get("gallery-popup")) {
    class GalleryPopup extends HTMLElement {
      constructor() {
        super();

        this.swiperElement = this.querySelector(".gallery-popup__swiper");
        this.swiperPagination = this.querySelector(
          ".gallery-popup__swiper-pagination"
        );
        this.swiperButtonNext = this.querySelector(
          ".gallery-popup__swiper-button-next"
        );
        this.swiperButtonPrev = this.querySelector(
          ".gallery-popup__swiper-button-prev"
        );
        this.swiperScrollbar = this.querySelector(
          ".gallery-popup__swiper-scrollbar"
        );
        this.initializeSlider();
        this.addEventListeners();
      }

      initializeSlider() {
        if (this.swiperElement.swiper) {
          return;
        }
        const mobilePagination = this.querySelector(
          ".gallery-popup__pagination-mobile span"
        );
        const mobileButton = this.querySelector(
          ".gallery-popup__button--mobile > a"
        );

        const swipperFeatured = new Swiper(this.swiperElement, {
          slidesPerView: 1,
          slidesPerGroup: 1,
          spaceBetween: 0,
          keyboard: {
            enabled: true,
          },
          pagination: {
            el: this.swiperPagination,
            type: "custom",
            renderCustom: function (swiper, current, total) {
              return current + "/" + total;
            },
          },
          navigation: {
            nextEl: this.swiperButtonNext,
            prevEl: this.swiperButtonPrev,
          },
          scrollbar: {
            el: this.swiperScrollbar,
            draggable: true,
          },

          on: {
            slideChangeTransitionEnd: function () {
              let slideCurrentIndex = this.realIndex;
              mobilePagination.textContent = slideCurrentIndex + 1;
              const href = this.slides[this.realIndex].dataset.href;
              const text = this.slides[this.realIndex].dataset.text;

              mobileButton.href = href;
              mobileButton.querySelector("span").textContent = text;
            },
          },
        });
      }

      addEventListeners() {
        const overlayButton = this.querySelector(".gallery-popup__overlay");
        const closeButton = this.querySelector(".gallery-popup__back");
        const overlay = this.querySelector(".gallery-popup__modal-overlay");

        overlayButton.addEventListener("click", () => {
          overlay.classList.add("open");

          document.body.style.overflow = "hidden";
        });

        closeButton.addEventListener("click", () => {
          overlay.classList.remove("open");
          document.body.style.overflow = "auto";
        });
      }
    }

    customElements.define("gallery-popup", GalleryPopup);
  }
})();
